const TheTabs = () => import(/* webpackChunkName: "Fingerbank" */ '../../_components/TheTabsFingerbank')

export {
  TheTabs
}
